import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';
import { OutboxTypeEnum } from '../enums/outbox-type.enum';

/**
 * Create outbox DTO
 */
export class CreateOutboxDto {
	color?: string;
	@TransformInt()
	tenantId!: number;
	@TransformInt()
	userId!: number;
	type!: OutboxTypeEnum;
	channel?: DataDispatchChannelEnum;
	status!: OutboxStatusEnum;
	key!: string;
	context?: Record<string, any>;
	subject!: AppSubjectEnum;
	@TransformInt()
	subjectId!: number;
	dispatchToken!: string;
	@TransformInt()
	retryCount!: number;
	@TransformDate()
	nextRetryAt?: Date;
	@TransformDate()
	scheduledAt?: Date;
	leasedBy?: string;
	@TransformDate()
	leasedUntil?: Date;
	@TransformDate()
	dispatchedAt?: Date;
	dispatchError?: string;
}
